import { render, staticRenderFns } from "./DMRReport.vue?vue&type=template&id=488b3400&scoped=true&"
import script from "./DMRReport.vue?vue&type=script&lang=js&"
export * from "./DMRReport.vue?vue&type=script&lang=js&"
import style0 from "./DMRReport.vue?vue&type=style&index=0&id=488b3400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b3400",
  null
  
)

export default component.exports